// extracted by css-extract-rspack-plugin
var _1 = "ItemFeedPage-m_page-ZrexunCV dim-page";
export { _1 as "page" }
